import LegalPage from "@/components/site/LegalPage";

export default function TermsOfService() {
  return (
    <LegalPage
      kicker="Terms of Service"
      title="Terms"
      updated="December 2025"
      sections={[
        {
          heading: "Acceptance",
          body: [
            "By using bandcsystem.com and by placing an order with B&C System Wireline Operator, you agree to these Terms of Service. If you do not agree, do not use the site or place an order.",
          ],
        },
        {
          heading: "Products, Pricing & Availability",
          body: [
            "Prices, specifications, and availability shown on this site are subject to change without notice and are not binding until confirmed on your invoice.",
            "Product images and descriptions are provided in good faith but may vary from the delivered product. Refer to the manufacturer's datasheet for the authoritative specification.",
            "We reserve the right to correct pricing errors and cancel any order at any time before the invoice has been issued.",
          ],
        },
        {
          heading: "Orders, Invoicing & Payment",
          body: [
            "Orders placed on this site are quote requests until we issue a formal invoice. The invoice will include freight, taxes, and payment terms and is the binding order document.",
            "Payment methods and terms will be confirmed by our sales desk. Credit terms are available to qualified accounts on approval.",
          ],
        },
        {
          heading: "Delivery",
          body: [
            "Delivery times quoted are estimates only. Title and risk of loss pass to you when the goods are handed to the carrier at our facility (FOB origin), unless expressly agreed otherwise on the invoice.",
          ],
        },
        {
          heading: "Warranty",
          body: [
            "New products are covered by the original manufacturer's warranty. B&C System will assist with warranty claims but does not extend an independent warranty beyond that of the manufacturer, unless expressly stated in writing.",
            "Wireline field services are covered by the service scope agreed in the job program.",
          ],
        },
        {
          heading: "Limitation of Liability",
          body: [
            "To the maximum extent permitted by law, B&C System's total liability for any claim arising out of an order or use of this site is limited to the amount paid for the specific goods or services giving rise to the claim.",
            "We are not liable for any indirect, incidental, consequential, or punitive damages, including lost profits or downtime.",
          ],
        },
        {
          heading: "Safe Use",
          body: [
            "The electrical products offered on this site are intended for installation and use by qualified, licensed professionals in accordance with the National Electrical Code (NEC) and all applicable local codes. You are responsible for ensuring your installation is code-compliant and safe.",
          ],
        },
        {
          heading: "Governing Law",
          body: [
            "These Terms are governed by the laws of the State of South Carolina, United States, without regard to conflict-of-laws principles. Any dispute will be resolved in the state or federal courts sitting in South Carolina.",
          ],
        },
        {
          heading: "Contact",
          body: [
            "Questions about these Terms should be sent to order@bandcsystem.com or B&C System Wireline Operator, 114 Adger Rd, Pendleton, SC 29670, United States.",
          ],
        },
      ]}
    />
  );
}
